import React from 'react';

export function renderException(exception: any) {
    if (Array.isArray(exception)) {
        return (
            <ul>
                {exception.map((e, idx) => (
                    <li key={idx}>{e.toString()}</li>
                ))}
            </ul>
        );
    } else if (React.isValidElement(exception)) {
        return [exception];
    } else {
        let errorMsg;
        if (exception instanceof Error || exception.message) {
            errorMsg = exception.message;
        } else {
            errorMsg = exception.toString();
        }

        return <div>{errorMsg}</div>;
    }
}
